inputs-without-label-submit-to-destroy
  button(class="btn {opts.klass ? opts.klass : 'btn-danger'}" disabled="{opts.disabled}")
    i.feather.icon-trash
    | { opts.label }
  script(type="typescript").
    this.mixin('inputs.submit-destroy');
